export default {
  // 全球英语：待定
  xxxx: {
    ad1: [],
    ad2: [],
  },
  // 全球英语 语言 + 国家
  get en_gl() {
    return this["hi"];
  },
  // 印度英语 语言 + 国家
  get en_in() {
    return this["en"];
  },
  // 印尼语 语言 + 国家
  get id_id() {
    return this["id"];
  },
  // 印度印地语 语言 + 国家
  get hi_in() {
    return this["hi"];
  },
  // 印度英语
  en: {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1749105857238-0",
        slot: "/23161678951/v_ls_dismore_comfortweather_20250602_320x100_1",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-36",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749105888526-0",
        slot: "/23161678951/v_ls_dismore_comfortweather_20250602_320x100_2",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },

        // type: "anchor",
        // slot: "/23161678951/v_ls_dismore_comfortweather_20250602_320x100_2",

        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1749105914764-0",
        slot: "/23161678951/v_ls_dismore_comfortweather_20241031_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-30",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749105940913-0",
        slot: "/23161678951/v_ls_dismore_comfortweather_20241031_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-31",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749105968582-0",
        slot: "/23161678951/v_ls_dismore_comfortweather_20241031_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-32",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749105996354-0",
        slot: "/23161678951/v_ls_dismore_comfortweather_20241031_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-33",
      },
    ],
  },

  // 印地语
  hi: {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1749277515902-0",
        slot: "/23161678951/v_ls_dismore_en_comfortweather_20250602_320x100_1",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-36",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749277543485-0",
        slot: "/23161678951/v_ls_dismore_en_comfortweather_20250602_320x100_2",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },

        // type: "anchor",
        // slot: "/23161678951/v_ls_dismore_en_comfortweather_20250602_320x100_2",

        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1749277572287-0",
        slot: "/23161678951/v_ls_dismore_en_comfortweather_20250602_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-30",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749277597546-0",
        slot: "/23161678951/v_ls_dismore_en_comfortweather_20250602_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-31",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749277622871-0",
        slot: "/23161678951/v_ls_dismore_en_comfortweather_20250602_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-32",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749277647660-0",
        slot: "/23161678951/v_ls_dismore_en_comfortweather_20250602_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-33",
      },
    ],
  },
  // 印尼语
  id: {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1749121498492-0",
        slot: "/23161678951/v_ls_dismore_id_comfortweather_20250602_320x100_1",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-36",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749121535753-0",
        slot: "/23161678951/v_ls_dismore_id_comfortweather_20250602_320x100_2",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },

        // type: "anchor",
        // slot: "/23161678951/v_ls_dismore_id_comfortweather_20250602_320x100_2",

        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1749121562428-0",
        slot: "/23161678951/v_ls_dismore_id_comfortweather_20250602_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-30",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749121589671-0",
        slot: "/23161678951/v_ls_dismore_id_comfortweather_20250602_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-31",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749121616445-0",
        slot: "/23161678951/v_ls_dismore_id_comfortweather_20250602_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-32",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749121640206-0",
        slot: "/23161678951/v_ls_dismore_id_comfortweather_20250602_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-33",
      },
    ],
  },
  get in() {
    return this["id"];
  },
  get in_id() {
    return this["id"];
  },
};
